import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import { PayerErrorDialog } from '../Error/ErrorDialog';
import { PayerError } from '../utils/errors';

const basePageSx = {
  animationName: 'fadeIn',
  animationDuration: '1s',
};

export type BasePageProps = {
  error: PayerError | null;
  onCloseError: () => void;
  children: ReactNode;
};

export const BasePage = ({ error, onCloseError, children }: BasePageProps) => {
  return (
    <Box sx={basePageSx}>
      <PayerErrorDialog error={error} onClose={onCloseError} />
      {children}
    </Box>
  );
};
